/* MMS shared holiday list (TEST theme, added 2026-10-16). ONE place for closed days, used by
   assets/mms-rental-dates.js (rental calendar) and assets/mms-zip-estimate.js (delivery estimate).
   Load it BEFORE those scripts: <script src="{{ 'mms-holidays.js' | asset_url }}" defer></script>

   SHOP closed days (no handling/shipping, rental calendar crossed off): Saturdays, Sundays and
     New Year's Day, Memorial Day, Independence Day, Labor Day, Thanksgiving, Day after Thanksgiving,
     Christmas Eve, Christmas Day. Fixed-date holidays on a Saturday are also closed the Friday before,
     on a Sunday the Monday after ("observed"). Christmas Eve / Day after Thanksgiving have no observed day.
   CARRIER no-delivery days (transit counting): Sundays, Saturdays (except Next Day Saturday) and the federal
     holidays carriers observe: New Year's, Memorial Day, July 4, Labor Day, Thanksgiving, Christmas (+ observed).
     Set CARRIER_ALL_FEDERAL = true to also skip MLK Day, Presidents Day, Juneteenth, Columbus Day, Veterans Day. */
(function () {
  if (window.MMSHolidays) return;
  var CARRIER_ALL_FEDERAL = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymdOf(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function nth(y, m, wd, n) { /* n-th weekday (0=Sun) of month m (0-based); n=-1 = last */
    if (n > 0) { var d = new Date(y, m, 1); d.setDate(1 + ((wd - d.getDay() + 7) % 7) + (n - 1) * 7); return d; }
    var e = new Date(y, m + 1, 0); e.setDate(e.getDate() - ((e.getDay() - wd + 7) % 7)); return e;
  }
  var cache = {};
  function lists(y) {
    if (cache[y]) return cache[y];
    var shop = {}, carrier = {};
    function add(t, d, n) { t[ymdOf(d)] = n; }
    function fixed(t, m, d, n) { var dt = new Date(y, m, d); add(t, dt, n);
      if (dt.getDay() === 6) add(t, new Date(y, m, d - 1), n + ' (observed)');
      if (dt.getDay() === 0) add(t, new Date(y, m, d + 1), n + ' (observed)'); }
    [shop, carrier].forEach(function (t) {
      fixed(t, 0, 1, 'New Year\u2019s Day'); add(t, nth(y, 4, 1, -1), 'Memorial Day'); fixed(t, 6, 4, 'Independence Day');
      add(t, nth(y, 8, 1, 1), 'Labor Day'); add(t, nth(y, 10, 4, 4), 'Thanksgiving'); fixed(t, 11, 25, 'Christmas Day');
    });
    var tg = nth(y, 10, 4, 4); add(shop, new Date(y, 10, tg.getDate() + 1), 'Day after Thanksgiving');
    add(shop, new Date(y, 11, 24), 'Christmas Eve');
    if (CARRIER_ALL_FEDERAL) {
      add(carrier, nth(y, 0, 1, 3), 'Martin Luther King Jr. Day'); add(carrier, nth(y, 1, 1, 3), 'Presidents Day');
      fixed(carrier, 5, 19, 'Juneteenth'); add(carrier, nth(y, 9, 1, 2), 'Columbus Day'); fixed(carrier, 10, 11, 'Veterans Day');
    }
    return (cache[y] = { shop: shop, carrier: carrier });
  }
  /* name or '' ; also checks next year (New Year's on a Saturday is observed Dec 31) */
  function shopHolidayName(ymd) { var y = +ymd.slice(0, 4); return lists(y).shop[ymd] || lists(y + 1).shop[ymd] || ''; }
  function carrierHolidayName(ymd) { var y = +ymd.slice(0, 4); return lists(y).carrier[ymd] || lists(y + 1).carrier[ymd] || ''; }
  window.MMSHolidays = {
    ymd: ymdOf,
    shopHolidayName: shopHolidayName,
    carrierHolidayName: carrierHolidayName,
    isShopOpen: function (d) { var w = d.getDay(); return w !== 0 && w !== 6 && !shopHolidayName(ymdOf(d)); },
    isCarrierDay: function (d, allowSaturday) { var w = d.getDay(); return w !== 0 && (w !== 6 || !!allowSaturday) && !carrierHolidayName(ymdOf(d)); }
  };
})();
